<template>
  <div class="portal-page-fill manage-role">
    <div class="role-manager" v-if="refinedRoles">
      <div class="top-header toolbar-card">
        <div class="search">
          <div class="icon">
            <span class="mdi mdi-magnify"></span>
          </div>
          <input class="search-bar" :placeholder="$t('search.roleplaceholder')" v-model="search" />
        </div>
        <!-- <div class="filters-container">
          <Tabs />
        </div> -->
        <div class="create-role">
          <span v-if="
                this.permissions.includes('Create-User')"
            @click="createUserRole"
            class="mdi mdi-plus-circle-outline add"
          ></span>
        </div>
      </div>
    </div>
    <div class="role-table portal-table-wrap table-card">
      <div class="portal-table-scroll">
        <table class="table">
      <thead>
        <tr class="table-header">
          <th class="user-table-headers" :class="[{'sorting': sort == 'id'}, direction]" @click="updateSort('id')">{{ $t("roles.Id") }}</th>
          <th class="user-table-headers" :class="[{'sorting': sort == 'name'}, direction]" @click="updateSort('name')">{{ $t("roles.name") }}</th>
          <th
            v-if="
              this.permissions.includes('Edit-Role') ||
              this.permissions.includes('Delete-Role')
            "
            width="280px"
          >
            {{ $t("roles.action") }}
          </th>
        </tr>
      </thead>
      <PortalTableBody
        :loading="loading"
        variant="role"
        :show-actions="hasActionColumn"
      >
      <template
        v-if="
          this.permissions.includes('Edit-Role') &&
          this.permissions.includes('Delete-Role')
        "
      >
        <tr class="table-data" v-for="(roles,idx) in refinedRoles" :key="idx">
          <td>{{ roles.id }}</td>
          <td>{{ roles.name }}</td>
          <td>
            <div class="row d-flex justify-content-center">
              <div class="icon">
                <span
                  class="mdi mdi-pencil edit"
                  @click="editRoleDetails(idx)"
                ></span>
              </div>
              <div class="icon">
                <span
                  class="mdi mdi-delete delete"
                  @click="openModel(roles.id)"
                ></span>
              </div>
            </div>
          </td>
        </tr>
      </template>
      <template
        v-else-if="
          this.permissions.includes('Edit-Role') &&
          !this.permissions.includes('Delete-Role')
        "
      >
        <tr class="table-data" v-for="(roles,idx) in refinedRoles" :key="idx">
          <td>{{ roles.id }}</td>
          <td>{{ roles.name }}</td>
          <td>
            <div class="row d-flex justify-content-center">
              <div class="icon">
                <span
                  class="mdi mdi-pencil edit"
                  @click="editRoleDetails(idx)"
                ></span>
              </div>
            </div>
          </td>
        </tr>
      </template>
      <template
        v-else-if="
          !this.permissions.includes('Edit-Role') &&
          this.permissions.includes('Delete-Role')
        "
      >
        <tr class="table-data" v-for="(roles,idx) in refinedRoles" :key="idx">
          <td>{{ roles.id }}</td>
          <td>{{ roles.name }}</td>
          <td>
            <div class="row d-flex justify-content-center">
              <div class="icon">
                <span
                  class="mdi mdi-delete delete"
                  @click="openModel(roles.id)"
                ></span>
              </div>
            </div>
          </td>
        </tr>
      </template>
      <template
        v-else-if="
          !this.permissions.includes('Edit-Role') &&
          !this.permissions.includes('Delete-Role')
        "
      >
        <tr class="table-data" v-for="(roles,idx) in refinedRoles" :key="idx">
          <td>{{ roles.id }}</td>
          <td>{{ roles.name }}</td>
        </tr>
      </template>
      </PortalTableBody>
    </table>
      </div>
    </div>
    <div class="footer portal-footer">
      <div class="results">
        <span class="mdi mdi-format-list-bulleted results-icon" aria-hidden="true"></span>
        {{ $t("displayresults.display") }} <strong>{{ resultsCopy }}</strong> {{ $t("displayresults.results")}}
      </div>
    </div>
    <!-- Pop Up Modal -->
    <div v-if="myModel">
      <transition name="model">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" @click="myModel = false">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="confirmation pb-4" style="text-align: center">
                    <h4>{{ $t("deletepop.message") }}</h4>
                  </div>
                  <div align="center">
                    <input
                      type="button"
                      class="btn btn-primary"
                      style="margin-right: 10px; width: 100px"
                      :value="$t('deletepop.okbtn')"
                      @click="deleteRole(modalData)"
                    />
                    <input
                      type="button"
                      class="btn btn-danger"
                      style="margin-left: 10px; width: 100px"
                      :value="$t('deletepop.cancelbtn')"
                      @click="myModel = false"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>-->

<script>
import axios from 'axios';
import { routeNames } from '../../js/routeNames';
import { decryptData } from '../../js/utils/encrypt';
import PortalTableBody from '../PortalTableBody.vue';
// import Tabs from './Tabs.vue';

export default {
  components: {
    PortalTableBody,
  },
  data() {
    return {
      myModel: false,
      getRoles: '',
      loading: false,
      roleid: '',
      permissions: [],
      modalData: '',
      search: '',
      filter: 'all',
    };
  },
  props:  {
    direction: String,
    sort: String
  },
  computed: {
    routeNames: () => {
      return routeNames;
    },
    refinedRoles() {
      if (!Array.isArray(this.getRoles)) {
        return [];
      }
      let refined = this.searchRoles(this.getRoles);
      if (this.sort) {
        refined = this.sortRoles(refined);
      }
      return this.direction === 'ascending' ? refined : refined.slice().reverse();
    },
    resultsCopy() {
      const length = this.refinedRoles.length;
      return `${length}`; 
    },
    hasActionColumn() {
      return (
        this.permissions.includes('Edit-Role') ||
        this.permissions.includes('Delete-Role')
      );
    }
  },
  mounted() {
    //Decrypting Permissions
    let mkLocalData = localStorage.getItem('Permissions');
    if (!mkLocalData) {
      mkLocalData = 'null';
    }
    const secretPermissionKey = process.env.KEY || 'myscecretkey';
    this.permissions = decryptData(mkLocalData, secretPermissionKey);
    this.loading = true;
    axios
      .get(this.$hostName + '/getAllRoles')
      .then((response) => {
        this.getRoles = response.data.roles;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    refreshPortalPage() {
      this.getRole();
    },
    updateSort(value) {
      this.$emit('updateSort', value);
    },
    createUserRole() {
      this.$router.push({ name: routeNames.newUserRole});
    },
    goToRoute(route) {
      if (this.navOpen) this.toggleNav();
      if (route == this.$router.currentRoute.name) return;
      this.$router.push({ name: route });
    },
    editRoleDetails(idx) {
      this.roleid = this.refinedRoles[idx].id;
      var roleid = this.refinedRoles[idx].id;
      var name = this.refinedRoles[idx].name;
      this.$router.push({ 
        name: 'edit-user-role', 
        params: { 
          roleid,
          name
        } 
      });
    },
    openModel(idx) {
      this.myModel = true;
      this.modalData = idx;
    },
    deleteRole(idx) {
      this.loading = true;
      axios
        .post(this.$hostName + '/roles/' + idx)
        .then((response) => {
          if (response.status == 202) {
            this.loading = false;
            this.myModel = false;
            this.$alert('Role is in use, unassign the role to delete');
          } else {
            this.getRole();
          }
        });
    },
    searchRoles(data) {
      const rows = Array.isArray(data) ? data : [];
      if (!this.search) return rows;
      return rows.filter((roles) => {
        return (
          (roles.name &&
            roles.name
              .toString()
              .toLowerCase()
              .includes(this.search.toString().toLowerCase()))
        );
      });
    },
    sortRoles(data) {
      const rows = Array.isArray(data) ? data.slice() : [];
      switch(this.sort) {
        case 'id':
        case 'name':
          return rows.sort( (userA, userB) => {
            if(userA[this.sort] < userB[this.sort]) { return -1; }
            if(userA[this.sort] > userB[this.sort]) { return 1; }
            return 0;
          });

        default: 
          return rows;
      }
    },
    getRole() {
      axios
        .get(this.$hostName + '/getAllRoles')
        .then((response) => {
          this.getRoles = response.data.roles;
        })
        .finally(() => {
          this.loading = false;
          this.myModel = false;
          this.$alert('Role Deleted Successfully');
        });
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
    width: 100%;
    height: 60px;
    min-height: 60px;
    background-color: $general-gray-light;
    padding: 0 25px;
    border-top: solid 1px $general-white;
    position: absolute;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .results {
      display: flex;
      align-items: center;
      font-size: 12px;
      padding-right: 20px;
      color: $general-black-light;
    }
  }
.add-role {
  text-align: end;
  font-size: xx-large;
}
.add:hover {
  cursor: pointer;
}
#btn-align {
  margin-right: 5%;
  color: white;
}
.role-header {
  margin-top: 2%;
  margin-left: 5%;
  margin-right: 5%;
}
.delete {
  color: red;
  font-size: 25px;
  margin-left: 10px;
}
.delete:hover {
  cursor: pointer;
}
.edit {
  color: blue;
  font-size: 25px;
  margin-right: 10px;
}
.edit:hover {
  cursor: pointer;
}

.icon {
  font-size: 25px;
}
.table-data {
  text-align: center;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-content {
  width: 500px !important;
}
.role-manager {
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>